import React, { useState, useEffect, useCallback } from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import './styles.css'
import classNames from 'classnames'
import { useMediaQuery } from 'react-responsive'

const OPTIONS = { align: 'start' }
const OPTIONS_VERTICAL = { axis: 'y' }

const Carousel = (props) => {
    const { slides, options, render, heading, orientation = 'horizontal', buttonText } = props
    const [emblaRef, emblaApi] = useEmblaCarousel(
        options ?? orientation === 'horizontal' ? OPTIONS : OPTIONS_VERTICAL,
    )

    const isMobile = useMediaQuery({ maxWidth: 600 })

    const [prevBtnDisabled, setPrevBtnDisabled] = useState(true)
    const [nextBtnDisabled, setNextBtnDisabled] = useState(true)

    const onPrevButtonClick = useCallback(() => {
        if (!emblaApi) return
        emblaApi.scrollPrev()
    }, [emblaApi])

    const onNextButtonClick = useCallback(() => {
        if (!emblaApi) return
        emblaApi.scrollNext()
    }, [emblaApi])

    const onSelect = useCallback((emblaApi) => {
        setPrevBtnDisabled(!emblaApi.canScrollPrev())
        setNextBtnDisabled(!emblaApi.canScrollNext())
    }, [])

    useEffect(() => {
        if (!emblaApi) return

        onSelect(emblaApi)
        emblaApi.on('reInit', onSelect).on('select', onSelect)
    }, [emblaApi, onSelect])

    const MAX_COUNT = isMobile ? 1 : 3

    return (
        <section className="embla ">
            <div className="embla__controls">
                <h2 className="embla__heading">{heading}</h2>
                {slides.length > MAX_COUNT && (
                    <div className="embla__buttons">
                        <button
                            className="btn-embla"
                            type="button"
                            onClick={onPrevButtonClick}
                            disabled={prevBtnDisabled}
                        >
                            <span
                                className={classNames('material-icons-outlined', 'arrow-icon', {
                                    'arrow-left': true, // ← add condition for left arrow
                                    'btn-embla-vertical': orientation !== 'horizontal',
                                })}
                            >
                                arrow_right_alt
                            </span>
                            <span className="placeholder">Previous</span>
                        </button>

                        <button
                            className={'btn-embla'}
                            type="button"
                            onClick={onNextButtonClick}
                            disabled={nextBtnDisabled}
                        >
                            <span className="placeholder">{buttonText ?? 'See More..'}</span>
                            <span
                                className={classNames('material-icons-outlined', {
                                    'btn-embla-vertical ': orientation !== 'horizontal',
                                })}
                            >
                                arrow_right_alt
                            </span>
                        </button>
                    </div>
                )}
            </div>
            <div className="embla__viewport" ref={emblaRef}>
                <div
                    className={classNames('embla__container', {
                        'embla__container_vertical ': orientation !== 'horizontal',
                    })}
                >
                    {slides.map((item, index) => (
                        <div className="embla__slide" key={index}>
                            {render(item, index)}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default Carousel
